import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { ICaseItem, ICaseSearchRequestBody, ISearchRequestParams } from "../models/case-assignment.model";
import { IResponse } from "@app/lib/models/response.model";
import { map, Observable } from "rxjs";
import { ListOfFileItem, ListOfFilesResponse } from "@app/lib/models/list-of-files.model";
import { Router } from "@angular/router";


@Injectable({
    providedIn: 'root'
})
export class ListOfFilesService extends BaseHttpService {

  private baseUrl:string;
    constructor(private router: Router, http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
        this.baseUrl = this.appConfig.hostUrl;
    }

    /**
     * Search Case By case information
     * @param reqBody 
     * @param queryParams 
     * @returns 
     */

    searchCaseNumber(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams): Observable<IResponse<ICaseItem[]>> {
            return this.post<IResponse<ICaseItem[]>, ICaseSearchRequestBody>('case/search/by/case-number.htm', reqBody, { params: { ...queryParams } });
        }
   getPrint(reqBody: any): Observable<Blob> {
     const url = `${this.baseUrl}files/print-reciept.htm`;
     const params = new HttpParams()
             .set('caseNumber', reqBody['caseNumber']);
    return this.http.get(url, { params, responseType: 'blob' });
       }
     searchCaseDetailsIDR(reqBody: any) {
            return this.post<IResponse<ListOfFileItem[]>, any>(
              'case/files.htm',
              reqBody
            ).pipe(
              map((res: IResponse<ListOfFileItem[]>) => res.data || {})
            );
        }
    
}